<ul class="pagination" [ngClass]="smallSize ? 'pagination-sm': ''">
  <li *ngFor="let pg of pages"
      [class.active]="pg.active"
      [class.disabled]="!pg.enable && !pg.active"
      class="page-item"
      id="pagination{{pg.text}}">
    <span *ngIf="!pg.enable || pg.active">
      {{pg.text}}
    </span>
    <ng-container *ngIf="pg.enable && !pg.active">
      <a class="page-link"
         *ngIf="!useEvent"
         [routerLink]="baseLink"
         [queryParams]="pg.queryParams"
         queryParamsHandling="merge">{{pg.text}}</a>
      <a class="page-link"
         *ngIf="useEvent"
         href="javascript:void(0);"
         (click)="selectPage(pg, $event)">{{pg.text}}</a>
    </ng-container>

  </li>
</ul>
